// @flow weak

import React      from 'react';
import PropTypes  from 'prop-types';
import cx         from 'classnames';
import isEmpty        from "lodash.isempty";
import moment from "moment";
import AdsBanner from './AdsBanner';

const AsideRight = ({
  children,
  isAnimated,
  isExpanded
}) => ( 
  <aside className={
    cx({
      'right-side':             true,
      'right-side--top-margin': true,
      'aside-right-animated':   isAnimated,
      'strech':                 isExpanded
    })}>
    <AdsBanner />
    { children }
  </aside>
);

AsideRight.propTypes = {
  children:   PropTypes.node.isRequired,
  isAnimated: PropTypes.bool.isRequired,
  isExpanded: PropTypes.bool.isRequired
};

AsideRight.defaultProps = {
  isAnimated: true,
  isExpanded: false
};

export default AsideRight;



// WEBPACK FOOTER //
// ./src/app/components/aside/asideRight/AsideRight.js